import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'
import styled from 'styled-components'

import {
  changeReferralCodeDialogOpenAtom,
  createReferralCodeDialogOpenAtom,
  inviteReferralDialogOpenAtom,
} from '../../atoms/reatom-referral-dialogs'

import { ChangeReferralCodeDialog } from './referral-dialog/change-referral-code-dialog'
import { CreateReferralCodeDialog } from './referral-dialog/create-referral-code-dialog'
import { ViewReferralCodeDialog } from './referral-dialog/view-referral-code-dialog'

type Props = {}

export const ReferralDialogsController: React.FC<Props> = () => {
  const [createReferralCodeDialogOpen, setCreateReferralCodeDialogOpen] =
    useAtom(createReferralCodeDialogOpenAtom)
  const [changeReferralCodeDialogOpen, setChangeReferralCodeDialogOpen] =
    useAtom(changeReferralCodeDialogOpenAtom)

  const [inviteReferralDialogOpen, setInviteReferralDialogOpen] = useAtom(
    inviteReferralDialogOpenAtom,
  )

  return (
    <Root>
      <AnimatePresence>
        {createReferralCodeDialogOpen ? (
          <CreateReferralCodeDialog
            open={createReferralCodeDialogOpen}
            onOpenChange={setCreateReferralCodeDialogOpen}
          />
        ) : undefined}
      </AnimatePresence>
      <AnimatePresence>
        {changeReferralCodeDialogOpen ? (
          <ChangeReferralCodeDialog
            open={changeReferralCodeDialogOpen}
            onOpenChange={setChangeReferralCodeDialogOpen}
          />
        ) : undefined}
      </AnimatePresence>
      <AnimatePresence>
        {inviteReferralDialogOpen ? (
          <ViewReferralCodeDialog
            open={inviteReferralDialogOpen}
            onOpenChange={setInviteReferralDialogOpen}
          />
        ) : undefined}
      </AnimatePresence>
    </Root>
  )
}

const Root = styled.div``
